<!--
 * @FileDescription: 编辑器组件
 * @Author: Ronghao Zhu
 * @CreateTime: 2021/01/11 16:19:05
 * @LastEditors: Ronghao Zhu
 * @LastEditTime: 2021-03-12 09:23:08
-->

<template>
    <div class="editor-wrap">
        <vue-tinymce v-model="content" :setting="setting" />
    </div>
</template>

<script>
import axios from 'axios'

export default {
    name: 'tinyEditor',
    components: {},
    props: {},
    data() {
        return {
            content: '',
            setting: {
                height: '100%',
                branding: false,
                language: 'zh_CN',
                plugins: 'lists, advlist',
                mobile: {
                    elementpath: false,
                    toolbar: [
                        'undo redo alignleft aligncenter alignright alignjustify outdent indent bold italic underline forecolor backcolor numlist bullist formatselect'
                    ],
                    toolbar_mode: 'sliding',
                    statusbar: false
                }
            }
        }
    },
    watch: {},
    created() {},
    mounted() {
        window.getContent = this.getContent
        window.setHtmlPath = this.setHtmlPath
    },
    methods: {
        getContent() {
            return this.content
                .replace(/\t/g, '')
                .replace(/\n/g, '')
                .replace(/\u003C/g, '<')
        },
        setHtmlPath(params) {
            const url = params.split(',')[0]
            const isEdit = params.split(',')[1]
            axios.get(url).then(res => {
                if (res.status === 200) {
                    this.content = res.data
                    if (isEdit === '0') {
                        window.tinymce.activeEditor.setMode('readonly') // 编辑器只读模式
                    } else {
                        window.tinymce.activeEditor.setMode('design')
                    }
                } else {
                    return res.status
                }
            })
        }
    }
}
</script>

<style lang="scss" scoped>
.editor-wrap {
    height: 100%;
}
</style>
